import { initializeApp } from "firebase/app";


const firebaseConfig = {
  apiKey: "AIzaSyCJ6hPbPsNZzg_XeWsH6Ok_6hksiIMyyIQ",
  authDomain: "auth-weapon.firebaseapp.com",
  projectId: "auth-weapon",
  storageBucket: "auth-weapon.appspot.com",
  messagingSenderId: "956404225678",
  appId: "1:956404225678:web:207a44d2f3b7bea5c11bdf"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);